import { Component, Element, h, Host, Listen, Prop } from "@stencil/core";
import { inquiryCartUrl } from "./f-inquiry-config";
import state, { getInquiryData } from "@stores/inquiry.store";

@Component({
  tag: "f-inquiry-flyout",
  shadow: true,
})
export class FInquiryFlyout {
  @Element() el: HTMLFInquiryFlyoutElement;

  @Prop() buttonHiddenLabel = "Inquiry";
  @Prop() buttonTitle = this.buttonHiddenLabel;
  @Prop() closeButtonHiddenLabel;
  @Prop() expanderButtonHiddenLabel;
  @Prop() openCartButtonLabel = "Open inquiry cart";
  @Prop() quantityLabel = "Quantity: ";
  @Prop() titleLabel = "My inquiry cart";
  @Prop() totalNetPriceLabel = "Total amount";
  @Prop() emptyListLabel = "Inquiry list is empty";
  @Prop() errorMessageLabel = "An error occurred";
  @Prop() numberOfShownInquiry = 3;

  /** Specifies the starting number of items on the flyout list. */
  @Prop({ mutable: true }) badgeCounter = 0;

  @Listen("productAddedToInquiry", { target: "document" })
  async handleProductAddToInquiry(): Promise<void> {
    this.flyoutEl.openFlyout(false);
  }

  componentWillLoad(): void {
    getInquiryData();
    state.inquiriesCart.totalItems = this.badgeCounter;
  }

  private flyoutEl;

  render() {
    return (
      <Host data-test="mini-inquiry">
        <f-flyout-with-button
          flyoutTitle={`${this.titleLabel} ${
            state.inquiriesCart.totalItems
              ? `(${state.inquiriesCart.totalItems})`
              : ""
          }`}
          flyoutId="f-inquiry-flyout"
          ref={(el) => (this.flyoutEl = el)}
          buttonBadgeLabel={state.inquiriesCart.totalItems}
          buttonIconName="post-it"
          buttonTitle={this.buttonTitle}
          closeButtonHiddenLabel={this.closeButtonHiddenLabel}
          flyoutDataTest="flyout-inquiry"
        >
          <f-visually-hidden>{this.buttonHiddenLabel}</f-visually-hidden>
          <div slot="flyout-content">
            {state.is === "LOADED" && (
              <f-flyout-product-list
                entries={state.inquiriesCart.entries}
                quantityLabel={this.quantityLabel}
                openDetailsButtonLabel={this.openCartButtonLabel}
                priceLabel={this.totalNetPriceLabel}
                emptyListLabel={this.emptyListLabel}
                detailsUrl={inquiryCartUrl}
                numberOfItems={this.numberOfShownInquiry}
                expanderButtonHiddenLabel={this.expanderButtonHiddenLabel}
              />
            )}
            {state.is === "LOADING" && <f-flyout-loader />}
            {state.is === "ERROR" && (
              <f-flyout-message messageLabel={this.errorMessageLabel} />
            )}
          </div>
          <div slot="flyout-footer">
            {state.is === "ERROR" && (
              <f-flyout-footer
                label={this.openCartButtonLabel}
                link={inquiryCartUrl}
              />
            )}
          </div>
        </f-flyout-with-button>
      </Host>
    );
  }
}
